export const services = [
  {
    title: "UI/UX Design",
    shortDesc: "Transform ideas into intuitive, engaging designs.",
    detail:
      "We research users, map flows, and ship interface systems your engineering team can implement without guesswork. Deliverables typically include wireframes, interactive prototypes, and a reusable design system.",
    icon: "Layout",
    bullets: ["User Research", "Wireframing & Prototyping", "Design Systems", "Usability Testing"],
  },
  {
    title: "Website Development",
    shortDesc: "Custom web apps, SaaS, and SPAs.",
    detail:
      "From marketing sites to complex SaaS products, we build React and Next.js applications with clean architecture, SEO-friendly structure, CMS options, and performance budgets that hold up under real traffic.",
    icon: "Globe",
    bullets: ["React & Next.js", "E-commerce Platforms", "CMS Integration", "Performance Optimization"],
  },
  {
    title: "Mobile App Development",
    shortDesc: "Native, hybrid, and cross-platform apps.",
    detail:
      "We design and ship iOS and Android experiences with React Native or Flutter when speed matters, or native stacks when platform depth is required — including store submission support and backend integration.",
    icon: "Smartphone",
    bullets: ["iOS & Android Native", "React Native & Flutter", "App Store Optimization", "Backend Integration"],
  },
  {
    title: "AI Development",
    shortDesc: "Smart solutions, ML models, and automation.",
    detail:
      "We integrate LLMs and automation into production products carefully: clear prompts, retrieval where needed, monitoring, and UX that keeps humans in control of critical decisions.",
    icon: "Cpu",
    bullets: ["Custom LLM Integration", "Predictive Analytics", "Process Automation", "Computer Vision"],
  },
  {
    title: "Blockchain Development",
    shortDesc: "Smart contracts, DApps, and Web3 platforms.",
    detail:
      "We build wallet-connected apps, smart contracts, and marketplace experiences with an emphasis on security reviews, clear documentation, and chains your community already uses.",
    icon: "Database",
    bullets: ["Smart Contract Development", "DApp Creation", "Wallet Integration", "DeFi Solutions"],
  },
  {
    title: "Quality Assurance",
    shortDesc: "Manual + automated testing and audits.",
    detail:
      "Before launch we run structured QA: functional checks, regression suites, performance audits, and security-minded reviews so releases are predictable instead of stressful.",
    icon: "ShieldCheck",
    bullets: ["Automated Testing", "Performance Audits", "Security Penetration", "Continuous Integration"],
  },
];

export const projects = [
  {
    title: "SkinSeoul Storefront",
    client: "SkinSeoul",
    category: "E-commerce / AI",
    description:
      "Korean skincare commerce experience with brand discovery, authentic product catalog support, and SkinSight-style recommendation flows tailored to skin concerns.",
    results: ["K-beauty e-commerce"],
    tech: ["Next.js", "Node.js", "AI recommendations"],
    coverImage:
      "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?auto=format&fit=crop&w=1200&q=80",
    url: "https://skin-seoul.com",
  },
  {
    title: "ISCE Digital Cards",
    client: "ISCE Digital Concept",
    category: "Web / NFC",
    description:
      "Product surfaces and supporting platforms for NFC-powered digital cards, tap-to-share identity, and client delivery work such as Ariaria and Transpay.",
    results: ["NFC product UX"],
    tech: ["React", "Node.js", "NFC integrations"],
    coverImage:
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=800&q=80",
    url: "https://www.isce.tech",
  },
  {
    title: "Mustang IP Marketplace",
    client: "MustangIP",
    category: "Marketplace / AI",
    description:
      "CRM and patent marketplace platform — backend APIs, admin tools, and data workflows for listing, licensing, and selling intellectual property.",
    results: ["CRM + marketplace"],
    tech: ["APIs", "Admin tools", "Marketplace"],
    coverImage:
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=800&q=80",
    url: "https://mustangip.com",
  },
];

export const team = [
  { name: "Muhammad Shahzaib", role: "CEO", img: "/team-headshots/shahzaib.png", bio: "Leads product strategy and client partnerships across web, mobile, and Web3 builds." },
  { name: "Muhammad Sameer", role: "CTO", img: "/sameer.jpg", bio: "Owns technical architecture, delivery standards, and engineering quality." },
  { name: "Rabia Zaheer", role: "Frontend Developer", img: "https://randomuser.me/api/portraits/women/44.jpg", bio: "Builds responsive interfaces and component systems in React." },
  { name: "Muhammad Sharjeel", role: "Backend Developer", img: "/sharjeel.jpg", bio: "Designs APIs, databases, and reliable server-side workflows." },
  { name: "Tayyaba Khaksar", role: "Frontend Developer", img: "https://randomuser.me/api/portraits/women/68.jpg", bio: "Focuses on accessible UI and polished product interactions." },
  { name: "Nayab Shoukat", role: "Graphic Designer", img: "https://randomuser.me/api/portraits/women/32.jpg", bio: "Creates visual systems, brand assets, and marketing creative." },
];

export const testimonials = [
  {
    name: "Suraj Sharma",
    role: "CEO | Mustang IP",
    companyUrl: "https://mustangip.com",
    verified: true,
    img: "/testimonials/suraj-sharma.jpg",
    quote:
      "Quantum Spark Technology delivered solid, production-ready work on our Mustang IP CRM and marketplace. Clear communication, strong engineering, and dependable delivery throughout.",
  },
  {
    name: "Yinusah Isah",
    role: "CEO | ISCE Digital Concept",
    companyUrl: "https://www.isce.tech",
    linkedinUrl: "https://www.linkedin.com/in/yinusah-isah-172474169/",
    verified: true,
    img: "/testimonials/yinusah-isah.png",
    quote:
      "They delivered polished web and backend work for our NFC digital cards and client platforms like Ariaria and Transpay.",
  },
  {
    name: "Ryan Shriver",
    role: "Digital Marketing Manager | Patriot Mobile",
    companyUrl: "https://www.patriotmobile.com",
    linkedinUrl: "https://www.linkedin.com/in/missionsminded1/",
    verified: true,
    img: "/testimonials/ryan-shriver.png",
    quote:
      "Clean design and reliable backend work that power our go-to-market launches and HubSpot lead generation at Patriot Mobile.",
  },
  {
    name: "Kuen Park",
    role: "CEO | SkinSeoul",
    companyUrl: "https://skin-seoul.com",
    email: "kuen.park@skin-seoul.com",
    verified: true,
    img: "/kuen-park.png",
    quote:
      "They helped us launch SkinSeoul — 500+ authentic K-beauty brands with SkinSight AI and a shopping experience our customers trust.",
  },
];

export const SITE_URL = "https://quantumsparktechnology.com";
